import { Injectable } from "@angular/core";
import { LorenBaseEndpointsService } from "../../../loren-base-endpoints-service/loren-base-endpoints.service";
import { LorenAlarmsFilter } from "../../../../../features/loren-home/components/loren-home-alarms-table/constants/loren-alarms-filters.constant";

export type AlarmFilters = Partial<{
  [LorenAlarmsFilter.ASSET_IDS]: number[];
  [LorenAlarmsFilter.ASSET_GROUP_IDS]: number[];
  [LorenAlarmsFilter.ASSET_METERING_TYPE]: string;
  [LorenAlarmsFilter.IS_CRITICAL]: boolean | string;
}>;

@Injectable({
  providedIn: "root",
})
export class LorenAlarmsEndpointsService extends LorenBaseEndpointsService {
  constructor() {
    super();
  }

  getAlarms() {
    return `${this.getApiServerUrl()}/alarms`;
  }

  getAllAlarmsForAsset(page: number, perPage: number, assetId: number) {
    return `${this.getAlarms()}?page=${page}&size=${perPage}&assetIds=${assetId}`;
  }

  getFilteredAlarmsForAsset(
    page: number,
    perPage: number,
    assetId: number,
    filter: {
      [LorenAlarmsFilter.ASSET_METERING_TYPE]: string;
      [LorenAlarmsFilter.STATUS]: "ACTIVE" | undefined;
    }
  ) {
    const getFilterWrapper = (f: LorenAlarmsFilter) =>
      this.getFilterString(filter, f);
    const filterStringsArr = [
      getFilterWrapper(LorenAlarmsFilter.ASSET_METERING_TYPE),
      getFilterWrapper(LorenAlarmsFilter.START_TIME),
      getFilterWrapper(LorenAlarmsFilter.STATUS),
    ]
      .filter((f) => f)
      .join("&");
    return `${this.getAlarms()}?&page=${page}&size=${perPage}&assetIds=${assetId}&${filterStringsArr}`;
  }

  getFilteredAlarms(
    page: number,
    perPage: number,
    filter: AlarmFilters,
  ) {
    const getFilterWrapper = (f: LorenAlarmsFilter) => this.getFilterString(filter, f);

    const filterStringsArr = [
      getFilterWrapper(LorenAlarmsFilter.ASSET_IDS),
      getFilterWrapper(LorenAlarmsFilter.ASSET_GROUP_IDS),
      getFilterWrapper(LorenAlarmsFilter.ASSET_METERING_TYPE),
      getFilterWrapper(LorenAlarmsFilter.START_TIME),
      getFilterWrapper(LorenAlarmsFilter.IS_CRITICAL),
    ]
      .filter((f) => f)
      .join("&");
    return `${this.getAlarms()}?status=ACTIVE&page=${page}&size=${perPage}&${filterStringsArr}`;
  }

  private getFilterString(allFilters, filter: LorenAlarmsFilter) {
    return allFilters[filter] ? `${filter}=${allFilters[filter]}` : null;
  }
}
